import { WogaaCustomEvent } from "@services/SnowplowService";

export enum WogaaLayerEventTypes {
  RatingSubmit = 'RATING_SUBMIT',
  RatingCESSubmit = 'RATING_CES_SUBMIT',
  SubmitFeedback = 'SUBMIT_FEEDBACK',
  SubmitBugReportForm = 'SUBMIT_BUG_REPORT_FORM',
  StartTS = 'START_TS',
  CompleteTS = 'COMPLETE_TS',
  SetUserId = 'SET_USER_ID',
  OpenInformationalService = 'OPEN_IS_SENTIMENTS',
  DetectBot = 'DETECT_BOT',
}

interface Action {
  readonly type: WogaaLayerEventTypes;
}

interface Options {
  uniqueTransactionId: string;
}

interface CommonAttributes {
  rsid: string;
  sentimentsId: string;
  trackingId?: string;
  questionConfigId: number;
}

export interface TransactionalServiceAttributes {
  trackingId: string;
  abQuestionTesting: boolean;
  options: Options;
}

export interface CustomEventAttributes {
  trackingId: string;
  options: Options;
}

export interface RatingAttributes extends CommonAttributes {
  rating: number;
  ratingScaleDesign: number;
  ratingType?: number;
  variant?: string;
}

export interface FeedbackAttributes extends CommonAttributes {
  questionId: string;
  questionType: number;
  questionNumber: number;
  response: string;
  displayedOptions?: string;
  variant?: string;
}

export interface BotDetectAttributes extends CommonAttributes {
  label: string;
  value: number;
  content: object;
}
export interface BugReportFormMetadata {
  transactionId: string;
  rsid: string;
  trackingId?: string;
  questionConfigId?: number;
  responses: {
    label: string,
    questionNumber: number
    questionId: string,
    questionType: number,
    response: any
}[];
}
export interface BugReportFormAttributes extends CommonAttributes, WogaaCustomEvent{
  [key: string]: any;
}
export class RatingSubmit implements Action {
  readonly type = WogaaLayerEventTypes.RatingSubmit;

  constructor(public payload: RatingAttributes) {}
}

export class RatingCESSubmit implements Action {
  readonly type = WogaaLayerEventTypes.RatingCESSubmit;

  constructor(public payload: RatingAttributes) {}
}

export class SubmitFeedback implements Action {
  readonly type = WogaaLayerEventTypes.SubmitFeedback;

  constructor(public payload: FeedbackAttributes) {}
}
export class SubmitBugReportForm implements Action {
  readonly type = WogaaLayerEventTypes.SubmitBugReportForm;

  constructor(public payload: BugReportFormAttributes) {}
}
export class StartTS implements Action {
  readonly type = WogaaLayerEventTypes.StartTS;

  constructor(public payload: TransactionalServiceAttributes) {}
}

export class CompleteTS implements Action {
  readonly type = WogaaLayerEventTypes.CompleteTS;

  constructor(public payload: TransactionalServiceAttributes) {}
}

export class OpenInformationalServiceWidget implements Action {
  readonly type = WogaaLayerEventTypes.OpenInformationalService;
}

export class SetUserId implements Action {
  readonly type = WogaaLayerEventTypes.SetUserId;

  constructor(public payload: { id: string }) {}
}

export class DetectBot implements Action {
  readonly type = WogaaLayerEventTypes.DetectBot;

  constructor(public payload: BotDetectAttributes) {}
}

export type WogaaLayerActions =
  | RatingSubmit
  | RatingCESSubmit
  | SubmitFeedback
  | SubmitBugReportForm
  | StartTS
  | CompleteTS
  | SetUserId
  | OpenInformationalServiceWidget
  | DetectBot;
